import { render } from "./BottomTabBar.vue?vue&type=template&id=1912f192&scoped=true"
const script = {}

import "./BottomTabBar.vue?vue&type=style&index=0&id=1912f192&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1912f192"]])

export default __exports__